var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-input',{attrs:{"value":_vm.currentValue,"placeholder":_vm.$t('erp.rows.discountFormula')},on:{"input":_vm.handleInput,"blur":_vm.handleBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }